import React, { useState, useEffect, useRef } from 'react';
import './home.css';
 
import Homec1 from '../components/common/homec1';
import Eventsco from '../components/common/eventsco';
 
import h1 from '../assets/h1Icon.svg';
import h2 from '../assets/h2Icon.svg';
import h3 from '../assets/h3Icon.svg';
import h4 from '../assets/h4Icon.svg';
 
import e1 from '../assets/event1.png';
import e2 from '../assets/event2image 25.png';
import e3 from '../assets/event3image 31.png';
 
import ts1 from '../assets/ts1Image (RUNWAY COLLECTION).png';
import ts2 from '../assets/ts2Image (EXCLUSIVE PREVIEW).png';
import ts3 from '../assets/ts3image 63.png';
 
import dd1 from '../assets/dd1.jpg';
import dd2 from '../assets/dd2mage 61.png';
import dd3 from '../assets/dd3image 62.png';
 
import popupimg from '../assets/image57.png';
 
import { useNavigate } from 'react-router-dom';
import Nav from '../components/layout/nav';

import { supabase } from '../supabase';
import Runwayc from '../components/common/runwayc';
 
const useReveal = (options = {}) => {
    const ref = useRef(null);
 
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
 
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                el.classList.add('visible');
                observer.unobserve(el);
            }
        }, { threshold: 0.12, ...options });
 
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
 
    return ref;
};
const Home = () => {
 
    const navigate = useNavigate();
 
    const [active, setActive]     = useState('designers');
    const [designers, setDesigners] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
 
    const runwayRef   = useReveal();
    const eventsRef   = useReveal();
    const designerRef = useReveal();
 
    useEffect(() => {
        const timer = setTimeout(() => setShowPopup(true), 1800);
        return () => clearTimeout(timer);
    }, []);
 
    useEffect(() => {
        const fetchDesigners = async () => {
            const { data, error } = await supabase.from('designers').select('*');
            if (error) console.log(error);
            else setDesigners(data);
        };
        fetchDesigners();
    }, []);
 
    const handleTab = (tab, path) => {
        setActive(tab);
        navigate(path);
    };
 
    const d1 = designers[0];
    const d2 = designers[1];
    const d3 = designers[2];
 
    return (
        <>
            <section>
                <div className="hcontainer">
                    {showPopup && (
                        <div className='popupoverlay'>
                            <div className='popupcard'>
 
                                <div className='popupclose' onClick={() => setShowPopup(false)}>✕</div>
 
                                <img src={popupimg} alt="" className='popupimg' />
                                <div className='popupgradient'></div>
 
                                <div className='popupcontent'>
                                    <h5 className='popuptag'>EXCLUSIVE EVENT</h5>
                                    <h1 className='popuptitle'>RUNWAY COLLECTION 2026</h1>
                                    <p className='popupdesc'>
                                        Discover the future of Egyptian fashion with elite designers and exclusive previews.
                                    </p>
                                    <button className='popupbtn'>RESERVE NOW</button>
                                </div>
 
                            </div>
                        </div>
                    )}
 
                 
                    <div className="homeee">
                        <div className="homeeeoverlay">
 
                           
                            <div className='homediv1'>
 
                                <div className='titlediv1'>
                                    <div className='titlediv2'>
                                        <h2>Egypt Fashion Week</h2>
                                        <h1>Welcome Back</h1>
                                    </div>
                                    <div className='noti'></div>
                                </div>
 
                                
                                <div className='homediv2'>
                                    <div onClick={() => navigate('/myticket')}>
                                        <Homec1 hicon={h1} hcompt='My Ticket' />
                                    </div>
                                    <div onClick={() => navigate('/map')}>
                                        <Homec1 hicon={h2} hcompt='Map' />
                                    </div>
                                    <div onClick={() => navigate('/schedule')}>
                                        <Homec1 hicon={h3} hcompt='Schedule' />
                                    </div>
                                    <div onClick={() => navigate('/rate')}>
                                        <Homec1 hicon={h4} hcompt='Rate' />
                                    </div>
                                </div>
 
                                <div className='searchhome'>
                                    <div className='searchicon'></div>
                                    <h6 className='searchtextt'>Search designers...</h6>
                                </div>
 
                            </div>
 
                           
                            <div className='homebigdiv'>
 
                           
                                <div className='homediv6 reveal' ref={runwayRef}>
 
                                    <div className='runwaywrapper'>
                                        <div className="runwaywrapper">
                                            <div className="runwaycbigdiv">
 
                                                <div className="runwaygroup">
                                                    <Runwayc numbbb="01" runwaycc="RUNWAY COLLECTION" photorunway={ts1} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="02" runwaycc="RUNWAY COLLECTION" photorunway={ts2} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="03" runwaycc="RUNWAY COLLECTION" photorunway={ts3} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="04" runwaycc="RUNWAY COLLECTION" photorunway={dd1} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="05" runwaycc="RUNWAY COLLECTION" photorunway={dd2} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="06" runwaycc="RUNWAY COLLECTION" photorunway={dd3} springtext="Spring Summer 2026" />
                                                </div>
 
                                               
                                                <div className="runwaygroup">
                                                    <Runwayc numbbb="01" runwaycc="RUNWAY COLLECTION" photorunway={ts1} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="02" runwaycc="RUNWAY COLLECTION" photorunway={ts2} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="03" runwaycc="RUNWAY COLLECTION" photorunway={ts3} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="04" runwaycc="RUNWAY COLLECTION" photorunway={dd1} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="05" runwaycc="RUNWAY COLLECTION" photorunway={dd2} springtext="Spring Summer 2026" />
                                                    <Runwayc numbbb="06" runwaycc="RUNWAY COLLECTION" photorunway={dd3} springtext="Spring Summer 2026" />
                                                </div>
 
                                            </div>
                                        </div>
                                    </div>
 
                                    <div className='h6child1'>
                                        <h5>Upcoming Events</h5>
                                    </div>
 
                                 
                                    <div className='eventssdiv reveal' ref={eventsRef}>
                                        <Eventsco fepic={e1} fet1='May 15, 2026' fet2='OPENING NIGHT GALA'  fet3='Haute Couture Spring 2026' />
                                        <Eventsco fepic={e3} fet1='May 16, 2026' fet2='EFW'                  fet3='Meet Egyptian Fashion' />
                                        <Eventsco fepic={e2} fet1='May 17, 2026' fet2='OPENING NIGHT GALA'  fet3='Haute Couture Spring 2026' />
                                        <Eventsco fepic={e2} fet1='May 17, 2026' fet2='OPENING NIGHT GALA'  fet3='Haute Couture Spring 2026' />
                                        <Eventsco fepic={e2} fet1='May 17, 2026' fet2='OPENING NIGHT GALA'  fet3='Haute Couture Spring 2026' />
                                    </div>
 
                                </div>
 
                                <div className='homediv7 reveal' ref={designerRef}>
 
                                    <div className='h6child1'>
                                        <h5>Designer Spotlight</h5>
                                    </div>
 
                                    <div className='ddesignersdiv'>
 
                                        {d1 && (
                                            <div className='designersnap activecard stagger-1'>
                                                <div className='designercard'>
                                                    <img src={dd1} alt="" className='designerimg' />
                                                    <div className='designeroverlay'></div>
                                                    <div className='designercontent'>
                                                        <p className='designerstyle'>{d1.style}</p>
                                                        <h2 className='designername'>{d1.name}</h2>
                                                        <div className='designerbottom'>
                                                            <div className='designerline'></div>
                                                            <span>VIEW PROFILE</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
 
                                        {d2 && (
                                            <div className='designersnap centercard stagger-2'>
                                                <div className='designercard designercardcenter'>
                                                    <img src={dd2} alt="" className='designerimg' />
                                                    <div className='designeroverlay'></div>
                                                    <div className='designercontent'>
                                                        <p className='designerstyle'>{d2.style}</p>
                                                        <h2 className='designername'>{d2.name}</h2>
                                                        <div className='designerbottom'>
                                                            <div className='designerline'></div>
                                                            <span>VIEW PROFILE</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
 
                                        {d3 && (
                                            <div className='designersnap activecard stagger-3'>
                                                <div className='designercard'>
                                                    <img src={dd3} alt="" className='designerimg' />
                                                    <div className='designeroverlay'></div>
                                                    <div className='designercontent'>
                                                        <p className='designerstyle'>{d3.style}</p>
                                                        <h2 className='designername'>{d3.name}</h2>
                                                        <div className='designerbottom'>
                                                            <div className='designerline'></div>
                                                            <span>VIEW PROFILE</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
 
                                    </div>
                                </div>
 
                            </div>
                        </div>
                    </div>
 
                    <Nav />
 
                </div>
            </section>
        </>
    );
};
 
export default Home;